import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import classes from "./GRN.module.css";
import { useSelector } from "react-redux/es/hooks/useSelector";
// import componentns
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import {
  Modal,
  Fade,
  Box,
  Tabs,
  Tab,
  TablePagination,
  Chip,
  Tooltip,
  CircularProgress,
} from "@mui/material";

import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import SelectCountry from "../../../components/Dashboard/amount/SelectCountry";
import { CurrencyContext } from "../../../context/CurrencyContext";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useLocation } from "react-router-dom";
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import FilterBar from "../../../components/common/FilterBar/FilterBar";
import PaginantionComponent from "../../../components/common/Pagination/PaginationComponent";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGRNOffline } from "../../../offline";
import { grnOfflineRepository } from "../../../offline/repositories/grnRepository";
import { masterDataRepository } from "../../../offline/repositories/master-data.repository";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
const GRNSystem = () => {
  const loginData = useSelector((state) => state.loginData.value);

  console.log(loginData);

  const {
    fromCurrency,
    setFromCurrency,
    toCurrency,
    countryName,
    setToCurrency,
    firstAmount,
    setFirstAmount,
  } = useContext(CurrencyContext);

  const location = useLocation();

  const [user_token] = useState(loginData?.user?.token);
  const [auth_token] = useState(loginData?.auth_token);

  const [access_type] = useState(loginData?.access_type);
  const [designation] = useState(loginData?.user?.designation);

  const [selectedGrn, setSelectedGrn] = useState(null);

  const [user_details] = useState(loginData?.user);
  var curr = new Date();
  curr.setDate(curr.getDate());
  var date = curr.toISOString().substring(0, 10);

  // state for within component
  const [getviewgrn, setViewGRN] = useState(false);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [selectedPO, setSelectedPO] = useState(null);
  const [items, setItems] = useState({});

  const [getponumber, setPONumber] = useState([]);
  const [getpoItems, setPoItems] = useState([]);
  const [itemCatalog, setItemCatalog] = useState([]);

  const [userlist, setUserList] = useState([]);

  const [successpopup, setSuccessPopUp] = useState(false);
  const [getuserpopupherotext, setUserPopupHeroText] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [poFieldErrors, setPoFieldErrors] = useState({});
  const receivedByRefs = useRef({});
  const [itemFieldErrors, setItemFieldErrors] = useState({});
  const qtyReceivedRefs = useRef({});

  const [searchText, setSearchText] = useState("");
  const [filterQuery, setFilterQuery] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [page, setPage] = useState(1);
  const [poInvoiceMap, setPoInvoiceMap] = useState({});
  const {
    grnList,
    loading: loadingGrnTable,
    refreshGRN,
    createGRN,
  } = useGRNOffline(auth_token, user_token);

  /**
   * @function getAllPoNumbers
   * @description Get all purchase order numbers also sync with API for offline grn
   * @returns {Promise<void>}
   */

  const loadCreateSupportData = useCallback(async () => {
    try {
      const [supportData, items] = await Promise.all([
        grnOfflineRepository.getCreateSupportData(auth_token, user_token),
        masterDataRepository.syncItems(auth_token, user_token),
      ]);
      const { users, invoices, purchaseOrders } = supportData;

      const invoiceLookup = {};
      (invoices || []).forEach((invoice) => {
        if (invoice?.pi_po_number) {
          invoiceLookup[invoice.pi_po_number] = invoice.invoice_number || "";
        }
      });

      const poNumbers = (purchaseOrders || []).map((po) => ({
        poNo: po.purchase_order_no,
        supplier: po.vendor?.company_name || "",
        invoiceNo:
          po.invoice_number || invoiceLookup[po.purchase_order_no] || "",
      }));

      setPONumber(poNumbers);
      setUserList(users || []);
      setPoItems(invoices || []);
      setItemCatalog(Array.isArray(items) ? items : []);

      const invoiceMap = {};
      (purchaseOrders || []).forEach((po) => {
        invoiceMap[po.purchase_order_no] =
          po.invoice_number || invoiceLookup[po.purchase_order_no] || "";
      });

      setPoInvoiceMap(invoiceMap);
    } catch (error) {
      console.error("Error loading GRN create support data:", error);
    }
  }, [auth_token, user_token]);

  useEffect(() => {
    if (!getviewgrn) return;

    if (
      getponumber.length === 0 ||
      getpoItems.length === 0 ||
      userlist.length === 0
    ) {
      loadCreateSupportData();
    }
  }, [
    getviewgrn,
    getponumber.length,
    getpoItems.length,
    userlist.length,
    loadCreateSupportData,
  ]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const action = params.get("action");
    if (action === "create") {
      openCreateGRN();
    }
  }, [location.search]);

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, grn_search } = JSON.parse(chatActionRaw);

    if (action === "search_grn") {
      setSearchText(grn_search);
    }
  }, []);

  const groupGRN = (rows) => {
    const map = {};

    rows.forEach((row) => {
      const key = row.grn_number;

      if (!map[key]) {
        map[key] = {
          grn_number: row.grn_number,
          grn_token: row.grn_token,

          purchase_order_no: row.purchase_order_no,
          invoice_number: row.invoice_number || "",
          vendor: row.vendor,
          receiver_name: row.receiver_name,
          created_at: row.created_at,

          overall_approval_status: row.overall_approval_status,
          approvals: row.approvals || [],

          items: [],
        };
      }

      map[key].items.push(row);
    });

    return Object.values(map).sort((a, b) => {
      const aTime = new Date(a.created_at).getTime();
      const bTime = new Date(b.created_at).getTime();
      return (
        (Number.isNaN(bTime) ? 0 : bTime) - (Number.isNaN(aTime) ? 0 : aTime)
      );
    });
  };
  const handleAddPO = () => {
    const currentDate = new Date().toISOString().split("T")[0];

    const newPO = {
      id: Date.now(),
      poNo: "",
      supplier: "",
      invoiceNo: "",
      invoiceDate: currentDate,
      deliveryDate: currentDate,
      receivedBy: "",
      receivedByToken: "",
      department: "",
    };
    setPurchaseOrders([...purchaseOrders, newPO]);
  };

  const handleRemovePO = (id) => {
    setPurchaseOrders(purchaseOrders.filter((po) => po.id !== id));
    setItems((prev) => {
      const updatedItems = { ...prev };
      delete updatedItems[id];
      return updatedItems;
    });
    if (selectedPO === id) setSelectedPO(null);
  };

  const handlePOInputChange = (id, field, value) => {
    console.log({ field, value });
    if (field === "receivedBy") {
      setValidationError("");
      setPoFieldErrors((prev) => {
        if (!prev?.[id]) return prev;
        const next = { ...prev };
        delete next[id];
        return next;
      });
    }
    setPurchaseOrders(
      purchaseOrders.map((po) => {
        if (po.id === id) {
          let updatedPO = { ...po, [field]: value };

          if (field === "receivedBy") {
            const selectedUser = userlist.find((user) => user.token === value);
            if (selectedUser) {
              const fullName =
                `${selectedUser.first_name || ""} ${selectedUser.last_name || ""}`.trim();
              updatedPO.receivedBy = fullName || selectedUser.email || "";
              updatedPO.receivedByToken = selectedUser.token || "";
              updatedPO.received_email = selectedUser.email || "";
              updatedPO.department = selectedUser.department || "";
            } else {
              updatedPO.receivedBy = "";
              updatedPO.receivedByToken = "";
              updatedPO.received_email = "";
              updatedPO.department = "";
            }
          }

          if (field === "poNo") {
            const selectedPO = getponumber.find(
              (poOption) => poOption.poNo === value,
            );
            updatedPO.supplier = selectedPO ? selectedPO.supplier : "";
            updatedPO.invoiceNo = selectedPO ? selectedPO.invoiceNo : "";
          }

          return updatedPO;
        }
        return po;
      }),
    );
  };

  const getInvoiceItemsByInvoiceNo = async (invoiceNo, poNo) => {
    try {
      const invoice =
        getpoItems.find(
          (item) =>
            item.invoice_number === invoiceNo || item.pi_po_number === poNo,
        ) || (await grnOfflineRepository.getInvoiceByPONumber(poNo));

      if (Array.isArray(invoice?.items)) {
        return invoice.items;
      }

      const cachedItems = await grnOfflineRepository.getInvoiceItems(invoiceNo);
      return Array.isArray(cachedItems) ? cachedItems : [];
    } catch (err) {
      console.error("Invoice item fetch failed", err);
      return [];
    }
  };

  const handleAddItem = async (poId) => {
    const selectedPO = purchaseOrders.find((po) => po.id === poId);
    if (!selectedPO) return;

    let invoiceItems = [];
    if (selectedPO?.invoiceNo || selectedPO?.poNo) {
      invoiceItems = await getInvoiceItemsByInvoiceNo(
        selectedPO.invoiceNo,
        selectedPO.poNo,
      );
    }

    const mappedItems = invoiceItems.map((item) => {
      const orderedQty = item.quantity ?? "";
      const unitPrice = item.unit_price ?? "";
      const receivedQty = orderedQty;

      return {
        item_token: "",
        item_code: item.item_code,
        name: item.item_name,
        description: item.description,
        quantityOrdered: orderedQty,
        quantityReceived: receivedQty, // same as ordered qty, but field stays editable
        uom: "Pieces",
        unitPrice,
        totalPrice:
          orderedQty !== "" && unitPrice !== ""
            ? Number(orderedQty) * Number(unitPrice)
            : item.total_amount,
        remarks: "",
      };
    });

    if (mappedItems.length > 0) {
      setItems((prev) => ({
        ...prev,
        [poId]: mappedItems,
      }));
      return;
    }

    const blankItem = {
      item_token: "",
      item_code: "",
      name: "",
      description: "",
      quantityOrdered: "",
      quantityReceived: "",
      uom: "Pieces",
      unitPrice: "",
      totalPrice: "",
      remarks: "",
    };

    setItems((prev) => ({
      ...prev,
      [poId]: [...(prev[poId] || []), blankItem],
    }));
  };

  const handleItemSelect = (poId, index, itemToken) => {
    const selectedItem = itemCatalog.find((item) => item.token === itemToken);

    setItems((prev) => {
      const updatedItems = [...(prev[poId] || [])];

      if (!updatedItems[index]) return prev;

      updatedItems[index] = {
        ...updatedItems[index],
        item_token: itemToken || "",
        name: selectedItem?.item_name || "",
        item_code: selectedItem?.item_code || "",
      };

      return { ...prev, [poId]: updatedItems };
    });
  };

  const handleAddItemsToggle = (po) => {
    if (!po?.poNo) return;
    setSelectedPO(selectedPO === po.id ? null : po.id);
  };

  const handleRemoveItem = (poId, index) => {
    setItems((prev) => ({
      ...prev,
      [poId]: prev[poId].filter((_, i) => i !== index),
    }));
  };

  const handleItemInputChange = (poId, index, field, value) => {
    if (field === "quantityReceived") {
      setValidationError("");
      setItemFieldErrors((prev) => {
        if (!prev?.[poId]?.[index]) return prev;
        const next = { ...prev };
        const perPo = { ...(next[poId] || {}) };
        delete perPo[index];
        next[poId] = perPo;
        return next;
      });
    }
    setItems((prev) => {
      const updatedItems = [...(prev[poId] || [])];

      const sanitizeQty = (v) => {
        if (v === null || v === undefined || v === "") return "";
        const raw = String(v);
        const noDecimal = raw.split(".")[0];
        return noDecimal.replace(/[^\d]/g, "");
      };

      if (field === "quantityOrdered" || field === "quantityReceived") {
        updatedItems[index][field] = sanitizeQty(value);
      } else {
        updatedItems[index][field] = value;
      }

      const parseNullableNumber = (v) => {
        if (v === null || v === undefined || v === "") return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      };

      const quantityReceived = parseNullableNumber(
        updatedItems[index].quantityReceived,
      );
      const quantityOrdered = parseNullableNumber(
        updatedItems[index].quantityOrdered,
      );
      const unitPrice = parseNullableNumber(updatedItems[index].unitPrice) ?? 0;

      const quantityForTotal =
        quantityReceived !== null ? quantityReceived : null;

      updatedItems[index].totalPrice =
        quantityForTotal === null ? "" : quantityForTotal * unitPrice;

      return { ...prev, [poId]: updatedItems };
    });
  };

  console.log(purchaseOrders);

  const grnData = groupGRN(Array.isArray(grnList) ? grnList : []);

  const resetDraftGRN = () => {
    setPurchaseOrders([]);
    setItems({});
    setSelectedPO(null);
    setIsSaving(false);
    setValidationError("");
    setPoFieldErrors({});
    setItemFieldErrors({});
  };

  const openCreateGRN = () => {
    resetDraftGRN();
    setViewGRN(true);
  };

  const closeCreateGRN = () => {
    resetDraftGRN();
    setViewGRN(false);
  };

  const handleSaveGRN = async () => {
    if (isSaving) return;

    setValidationError("");
    setPoFieldErrors({});
    setItemFieldErrors({});

    const firstMissingReceivedBy = purchaseOrders.find(
      (po) => po?.poNo && !po?.receivedByToken,
    );

    if (firstMissingReceivedBy) {
      setValidationError(
        "Received By is mandatory. Please select a receiver before saving.",
      );
      setPoFieldErrors({ [firstMissingReceivedBy.id]: { receivedBy: true } });
      const el = receivedByRefs.current?.[firstMissingReceivedBy.id];
      if (el && typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        if (typeof el.focus === "function") el.focus();
      }
      return;
    }

    const findFirstMissingQtyReceived = () => {
      for (const po of purchaseOrders) {
        const poItems = items?.[po.id] || [];
        for (let i = 0; i < poItems.length; i += 1) {
          const row = poItems[i] || {};
          const hasItemIdentity =
            !!row?.item_token || !!row?.name || !!row?.item_code;
          if (!hasItemIdentity) continue;

          const v = row?.quantityReceived;
          if (v === null || v === undefined || String(v).trim() === "") {
            return { poId: po.id, rowIndex: i };
          }
        }
      }
      return null;
    };

    const missingQty = findFirstMissingQtyReceived();
    if (missingQty) {
      setValidationError(
        "Quantity Received is mandatory. Please fill it for all items before saving.",
      );
      setItemFieldErrors({
        [missingQty.poId]: {
          [missingQty.rowIndex]: { quantityReceived: true },
        },
      });
      setSelectedPO(missingQty.poId);
      setTimeout(() => {
        const key = `${missingQty.poId}_${missingQty.rowIndex}`;
        const el = qtyReceivedRefs.current?.[key];
        if (el && typeof el.scrollIntoView === "function") {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          if (typeof el.focus === "function") el.focus();
        }
      }, 0);
      return;
    }

    const formattedData = purchaseOrders.flatMap((po) => {
      return (items[po.id] || []).map((item) => ({
        user_token: loginData?.user?.user_token || user_token,
        poNo: po.poNo,
        supplier_name: po.supplier,
        invoiceNo: po.invoiceNo,
        delivery_date: po.deliveryDate ? `${po.deliveryDate}T00:00:00Z` : null,
        received_by: po.receivedBy,
        received_email: po.received_email || loginData?.user?.email || "",
        department: po.department,
        item_name: item.name,
        item_code: item.item_code || "",
        description: item.description,
        q_ordered: item.quantityOrdered,
        q_received: item.quantityReceived,
        uom: item.uom,
        unit_price: item.unitPrice,
        remarks: item.remarks,
        total_price: item.totalPrice,
      }));
    });

    setIsSaving(true);

    try {
      const result = await createGRN(formattedData);
      if (result?.success) {
        setSuccessPopUp(true);
        setUserPopupHeroText(
          result.offline ? "GRN Saved Offline" : "GRN Added Successfully",
        );
      }
    } finally {
      setIsSaving(false);
    }
  };

  const sentUserMessage = () => {
    resetDraftGRN();
    setViewGRN(false);
    setSuccessPopUp(false);
    refreshGRN();
  };

  const isCompleted = (items) =>
    items.every(
      (i) => Number(i.quantity_ordered) === Number(i.quantity_received),
    );
  const activeGRN = [];
  const completedGRN = [];

  grnData.forEach((grn) => {
    const activeItems = grn.items.filter(
      (i) => Number(i.quantity_ordered) !== Number(i.quantity_received),
    );

    const completedItems = grn.items.filter(
      (i) => Number(i.quantity_ordered) === Number(i.quantity_received),
    );

    if (activeItems.length > 0) {
      activeGRN.push({ ...grn, items: activeItems });
    }

    if (completedItems.length > 0) {
      completedGRN.push({ ...grn, items: completedItems });
    }
  });

  const filterGRNBySearch = (data) => {
    const q = searchText.trim().toLowerCase();
    if (!q) return data;

    return data.filter((grn) =>
      [
        grn.purchase_order_no,
        grn.invoice_number || poInvoiceMap?.[grn.purchase_order_no],
        grn.vendor,
        grn.receiver_name,
        grn.grn_number,
      ]
        .filter(Boolean)
        .some((field) => String(field).toLowerCase().trim().includes(q)),
    );
  };
  const normalizeApprovalStatus = (status) => {
    const normalized = String(status || "")
      .trim()
      .toLowerCase();
    if (!normalized) return "pending";
    if (normalized.includes("approve")) return "approved";
    if (normalized.includes("reject")) return "rejected";
    if (normalized.includes("pending") || normalized.includes("waiting")) {
      return "pending";
    }
    return normalized;
  };

  const filterGRNByApprovalStatus = (data) => {
    if (!filterQuery) return data;
    const normalizedFilter = String(filterQuery).trim().toLowerCase();

    return data.filter((grn) => {
      const status = normalizeApprovalStatus(grn?.overall_approval_status);
      if (normalizedFilter === "approved") return status === "approved";
      if (normalizedFilter === "pending") return status === "pending";
      return true;
    });
  };
  useEffect(() => {
    setPage(1);
  }, [searchText, filterQuery]);

  const filteredGRN = filterGRNBySearch(filterGRNByApprovalStatus(grnData));

  const paginatedGRN = filteredGRN.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage,
  );

  return (
    <>
      <div className={classes.users_tab_wrapper}>
        <div className={classes.users_topHeader}>
          <div className={`${classes.lhs} ${classes.flex}`}>
            <HeaderTitle titleText={"Goods Receipt Note (GRN)"} />
          </div>
        </div>
        <div className={classes.grncontainer}>
          {access_type !== "Buyer" && designation == "Store Assistant" && (
            <div className={classes.viewbtncontainer}>
              <button
                onClick={() => {
                  if (getviewgrn) {
                    closeCreateGRN();
                    return;
                  }

                  openCreateGRN();
                }}
                className={getviewgrn ? classes.backBtn : classes.viewBtn}
              >
                {getviewgrn ? "Back" : "Add GRN"}
              </button>
            </div>
          )}

          {!getviewgrn && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "1rem",
                flexWrap: "wrap",
              }}
            >
              <div style={{ flex: "1 1 320px", minWidth: "260px" }}>
                <SearchBar
                  value={searchText}
                  onChange={(value) => {
                    setSearchText(value);
                  }}
                />
              </div>
              <div style={{ flex: "0 0 320px", minWidth: "220px" }}>
                <FilterBar
                  filterValue={filterQuery}
                  onFilterChange={(query) => {
                    setFilterQuery(query);
                    setPage(1);
                  }}
                  options={[
                    { value: "", label: "All" },
                    { value: "pending", label: "Awaiting" },
                    { value: "approved", label: "Approved" },
                  ]}
                />
              </div>
            </div>
          )}

          {getviewgrn ? (
            <div className={classes.addGrnPage}>
              <div className={classes.sectionCard}>
                <div className={classes.sectionHeader}>
                  <div>
                    <h3 className={classes.sectionTitle}>GRN Header Details</h3>
                    <p className={classes.sectionSubtitle}>
                      Review company information and prepare the receipt note
                      with consistent vendor and receiver details.
                    </p>
                  </div>
                </div>

                <div className={classes.companydetails}>
                  <div className={classes.inputcontainer}>
                    <label>Company Name</label>
                    <input value={user_details.company_name} readOnly />
                  </div>

                  <div className={classes.inputcontainer}>
                    <label>Address</label>
                    <input
                      value={`${user_details.city},${user_details.state}`}
                      readOnly
                    />
                  </div>

                  <div className={classes.inputcontainer}>
                    <label>Contact Details</label>
                    <input value={`${user_details.email}`} readOnly />
                  </div>

                  <div className={classes.inputcontainer}>
                    <label>Date</label>
                    <input type="date" defaultValue={date} />
                  </div>
                </div>
              </div>

              <div className={classes.sectionCard}>
                <div className={classes.sectionHeader}>
                  <div>
                    <h3 className={classes.sectionTitle}>PO Receipt Mapping</h3>
                    <p className={classes.sectionSubtitle}>
                      Add purchase orders and attach the corresponding receiver
                      and invoice details before capturing item-level receipts.
                    </p>
                  </div>
                  <button onClick={handleAddPO} className={classes.addButton}>
                    Add PO
                  </button>
                </div>

                {validationError ? (
                  <div className={classes.validationError} role="alert">
                    {validationError}
                  </div>
                ) : null}

                <div className={classes.tableResponsiveWrapper}>
                  <table
                    className={`${classes.potable} ${classes.poMappingTable}`}
                  >
                    <thead>
                      <tr>
                        <th>PO ID</th>
                        <th>Supplier Name</th>
                        <th>Supplier Invoice ID</th>
                        <th>Supplier Invoice Date</th>
                        <th>Expected Delivery Date</th>
                        <th>Received By</th>
                        <th>Email</th>
                        <th>Department</th>
                        <th>Add Items</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {purchaseOrders.map((po, index) => {
                        console.log("Purchase Order Row:", {
                          index: index,
                          id: po.id,
                          poNo: po.poNo,
                          supplier: po.supplier,
                          invoiceNo: po.invoiceNo,
                          invoiceDate: po.invoiceDate,
                          deliveryDate: po.deliveryDate,
                          receivedBy: po.receivedBy,
                          received_email: po.received_email,
                          department: po.department,
                        });

                        return (
                          <tr key={po.id}>
                            <td>
                              <select
                                value={po.poNo}
                                onChange={(e) =>
                                  handlePOInputChange(
                                    po.id,
                                    "poNo",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="">Select PO ID</option>
                                {Array.isArray(getponumber) &&
                                  getponumber.map((poOption, index) => (
                                    <option key={index} value={poOption.poNo}>
                                      {poOption.poNo} - {poOption.supplier}
                                    </option>
                                  ))}
                              </select>
                            </td>

                            <td>
                              <input type="text" value={po.supplier} readOnly />
                            </td>

                            <td>
                              <input
                                type="text"
                                value={po.invoiceNo}
                                readOnly
                              />
                            </td>

                            <td>
                              <input
                                type="date"
                                value={po.invoiceDate}
                                onChange={(e) =>
                                  handlePOInputChange(
                                    po.id,
                                    "invoiceDate",
                                    e.target.value,
                                  )
                                }
                              />
                            </td>

                            <td>
                              <input
                                type="date"
                                value={po.deliveryDate || ""}
                                onChange={(e) =>
                                  handlePOInputChange(
                                    po.id,
                                    "deliveryDate",
                                    e.target.value,
                                  )
                                }
                              />
                            </td>

                            <td>
                              <select
                                ref={(el) => {
                                  if (el) receivedByRefs.current[po.id] = el;
                                }}
                                className={
                                  poFieldErrors?.[po.id]?.receivedBy
                                    ? classes.fieldError
                                    : ""
                                }
                                value={po.receivedByToken || ""}
                                aria-invalid={
                                  poFieldErrors?.[po.id]?.receivedBy
                                    ? "true"
                                    : "false"
                                }
                                onChange={(e) =>
                                  handlePOInputChange(
                                    po.id,
                                    "receivedBy",
                                    e.target.value,
                                  )
                                }
                              >
                                <option value="">Select User</option>
                                {userlist.map((user) => (
                                  <option key={user.token} value={user.token}>
                                    {`${user.first_name || ""} ${user.last_name || ""}`.trim()}
                                    {user.email ? ` (${user.email})` : ""}
                                  </option>
                                ))}
                              </select>
                              {poFieldErrors?.[po.id]?.receivedBy ? (
                                <div className={classes.fieldErrorText}>
                                  Required
                                </div>
                              ) : null}
                            </td>

                            <td>
                              <input
                                type="text"
                                value={po.received_email || ""}
                                readOnly
                              />
                            </td>

                            <td>
                              <input
                                type="text"
                                value={po.department || ""}
                                readOnly
                              />
                            </td>

                            <td>
                              <Tooltip
                                title={po.poNo ? "" : "Choose PO"}
                                placement="top"
                                disableHoverListener={!!po.poNo}
                                disableFocusListener={!!po.poNo}
                                disableTouchListener={!!po.poNo}
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "13px",
                                      fontFamily: "GilroyMedium",
                                    },
                                  },
                                }}
                              >
                                <span>
                                  <button
                                    type="button"
                                    disabled={!po.poNo}
                                    className={`${classes.iconCircleBtn} ${
                                      !po.poNo
                                        ? classes.iconCircleBtnDisabled
                                        : ""
                                    }`}
                                    onClick={() => handleAddItemsToggle(po)}
                                  >
                                    {selectedPO === po.id ? (
                                      <AddCircleOutlineIcon
                                        className={classes.collapseIcon}
                                      />
                                    ) : (
                                      <AddCircleOutlineIcon
                                        className={classes.expandIcon}
                                      />
                                    )}
                                  </button>
                                </span>
                              </Tooltip>
                            </td>

                            <td>
                              <button
                                onClick={() => handleRemovePO(po.id)}
                                className={classes.deleteIconBtn}
                              >
                                <DeleteOutlineIcon
                                  className={classes.deleteIcon}
                                />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              {selectedPO && (
                <div className={classes.itemwrapper}>
                  <div className={classes.sectionHeader}>
                    <div>
                      <h3 className={classes.sectionTitle}>
                        Items for PO ID{" "}
                        {
                          purchaseOrders.find((po) => po.id === selectedPO)
                            ?.poNo
                        }
                      </h3>
                      <p className={classes.sectionSubtitle}>
                        Capture received quantities, remarks, and totals for the
                        selected purchase order.
                      </p>
                    </div>
                    <button
                      onClick={() => handleAddItem(selectedPO)}
                      className={classes.addButton}
                    >
                      Add Item
                    </button>
                  </div>

                  <div className={classes.tableResponsiveWrapper}>
                    <table className={classes.potable}>
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>Item Code</th>
                          <th>Description</th>
                          <th>Quantity Ordered</th>
                          <th>Quantity Received</th>
                          <th>Unit of Measure</th>
                          <th>Unit Price</th>
                          <th>Total Price</th>
                          <th> Exception Remarks</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {(items[selectedPO] || []).map((item, index) => (
                          <tr key={index}>
                            <td style={{ width: "200px" }}>
                              {item?.name || item?.item_code ? (
                                <input
                                  type="text"
                                  className={classes.mediumInput}
                                  value={item.name}
                                  readOnly
                                />
                              ) : (
                                <select
                                  className={classes.mediumInput}
                                  value={item.item_token || ""}
                                  onChange={(e) =>
                                    handleItemSelect(
                                      selectedPO,
                                      index,
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="">
                                    {itemCatalog.length
                                      ? "Select Item"
                                      : "No items available"}
                                  </option>
                                  {itemCatalog.map((catalogItem) => (
                                    <option
                                      key={catalogItem.token}
                                      value={catalogItem.token}
                                    >
                                      {catalogItem.item_name}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </td>

                            {/* ITEM CODE (medium) */}
                            <td>
                              <input
                                type="text"
                                className={classes.mediumInput}
                                value={item.item_code}
                                readOnly
                              />
                            </td>

                            {/* DESCRIPTION (extra wide) */}
                            <td>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  minWidth: 0,
                                }}
                              >
                                <input
                                  type="text"
                                  className={classes.extraWideInput}
                                  value={item.description || ""}
                                  readOnly
                                  style={{
                                    minWidth: 0,
                                    flex: 1,
                                  }}
                                />

                                <Tooltip
                                  arrow
                                  placement="top"
                                  title={item.description || "No description"}
                                  componentsProps={{
                                    tooltip: {
                                      sx: {
                                        bgcolor: "#1f2937",
                                        fontSize: "13px",
                                        fontFamily: "gilroyMedium",
                                        padding: "10px 12px",
                                        borderRadius: "8px",
                                        maxWidth: "320px",
                                        lineHeight: 1.5,
                                      },
                                    },
                                    arrow: {
                                      sx: {
                                        color: "#1f2937",
                                      },
                                    },
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      color: "#2563eb",
                                    }}
                                  >
                                    <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                                  </span>
                                </Tooltip>
                              </Box>
                            </td>

                            <td>
                              <input
                                type="number"
                                className={classes.smallInput}
                                value={item.quantityOrdered}
                                min="0"
                                step="1"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                readOnly
                              />
                            </td>

                            {/* QUANTITY RECEIVED (small) */}
                            <td>
                              <input
                                type="number"
                                ref={(el) => {
                                  const key = `${selectedPO}_${index}`;
                                  if (el) qtyReceivedRefs.current[key] = el;
                                }}
                                className={`${classes.smallInput} ${
                                  itemFieldErrors?.[selectedPO]?.[index]
                                    ?.quantityReceived
                                    ? classes.fieldError
                                    : ""
                                }`}
                                value={item.quantityReceived}
                                min="0"
                                step="1"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                onWheel={(e) => e.target.blur()}
                                aria-invalid={
                                  itemFieldErrors?.[selectedPO]?.[index]
                                    ?.quantityReceived
                                    ? "true"
                                    : "false"
                                }
                                onChange={(e) =>
                                  handleItemInputChange(
                                    selectedPO,
                                    index,
                                    "quantityReceived",
                                    e.target.value,
                                  )
                                }
                              />
                              {itemFieldErrors?.[selectedPO]?.[index]
                                ?.quantityReceived ? (
                                <div className={classes.fieldErrorText}>
                                  Required
                                </div>
                              ) : null}
                            </td>

                            {/* UOM (medium) */}
                            <td>
                              <input
                                type="text"
                                className={classes.mediumInput}
                                value={item.uom}
                                readOnly
                              />
                            </td>

                            {/* UNIT PRICE (small) */}
                            <td>
                              <div
                                style={{
                                  position: "relative",
                                  width: "fit-content",
                                }}
                              >
                                <span
                                  style={{
                                    position: "absolute",
                                    left: "8px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    fontWeight: 600,
                                    color: "#555",
                                    pointerEvents: "none",
                                  }}
                                >
                                  ₹
                                </span>

                                <input
                                  type="text"
                                  className={classes.smallInput}
                                  value={Number(item.unitPrice).toLocaleString(
                                    "en-IN",
                                  )}
                                  readOnly
                                  style={{ paddingLeft: "22px" }}
                                />
                              </div>
                            </td>

                            {/* TOTAL PRICE (small) */}
                            <td>
                              <div
                                style={{
                                  position: "relative",
                                  width: "fit-content",
                                }}
                              >
                                <span
                                  style={{
                                    position: "absolute",
                                    left: "8px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    fontWeight: 600,
                                    color: "#555",
                                    pointerEvents: "none",
                                  }}
                                >
                                  ₹
                                </span>

                                <input
                                  type="text"
                                  className={classes.smallInput}
                                  value={Number(item.totalPrice).toLocaleString(
                                    "en-IN",
                                  )}
                                  readOnly
                                  style={{ paddingLeft: "22px" }}
                                />
                              </div>
                            </td>

                            {/* REMARKS (extra wide) */}
                            <td>
                              <input
                                type="text"
                                className={classes.extraWideInput}
                                value={item.remarks}
                                onChange={(e) =>
                                  handleItemInputChange(
                                    selectedPO,
                                    index,
                                    "remarks",
                                    e.target.value,
                                  )
                                }
                              />
                            </td>

                            {/* ACTION (delete icon) */}
                            <td>
                              <button
                                onClick={() =>
                                  handleRemoveItem(selectedPO, index)
                                }
                                className={classes.deleteIconBtn}
                              >
                                <DeleteOutlineIcon
                                  className={classes.deleteIcon}
                                />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className={classes.grnContainer}>
              {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tabValue}
                onChange={(event, newValue) => setTabValue(newValue)}
              >
                <Tab
                  label="Active GRN"
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    letterSpacing: "normal",
                  }}
                />

                <Tab
                  label="Completed GRN"
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    letterSpacing: "normal",
                  }}
                />
              </Tabs>
            </Box> */}

              {/* {tabValue === 0 ? (
              <div className={classes.tableResponsiveWrapper}>
                <GRNTable
                  title="Active GRN"
                  data={paginatedActiveGRN}
                  poInvoiceMap={poInvoiceMap}
                  setSelectedGrn={setSelectedGrn}
                />
              </div>
            ) : (
              <div className={classes.tableResponsiveWrapper}>
                <GRNTable
                  title="Completed GRN"
                  data={paginatedCompletedGRN}
                  poInvoiceMap={poInvoiceMap}
                  setSelectedGrn={setSelectedGrn}
                />
              </div>
            )} */}

              {loadingGrnTable && filteredGRN.length === 0 ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                  <CircularProgress size={30} />
                </Box>
              ) : (
                <GRNTable
                  title="All GRN"
                  data={paginatedGRN}
                  poInvoiceMap={poInvoiceMap}
                />
              )}
            </div>
          )}

          {/* ✅ ITEMS TABLE */}
          {selectedGrn && (
            <div className={classes.itemwrapper}>
              <HeaderTitle titleText="GRN Items" />

              <div className={classes.tableResponsiveWrapper}>
                <table className={classes.potable}>
                  <thead>
                    <tr>
                      <th>Item Code</th>
                      <th>Ordered Quantity</th>
                      <th>Received Quantity</th>
                      <th>Unit Price</th>
                      <th>Total Price</th>
                      <th> Exception Remarks</th>
                    </tr>
                  </thead>

                  <tbody>
                    {selectedGrn.items.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.description}</td>
                        <td>{item.quantity_ordered}</td>
                        <td>{item.quantity_received}</td>
                        <td>
                          ₹
                          {Number(item.unit_price || 0).toLocaleString("en-IN")}
                        </td>
                        <td>
                          ₹
                          {Number(item.total_price || 0).toLocaleString(
                            "en-IN",
                          )}
                        </td>
                        <td>{item.remarks || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {getviewgrn &&
            Object.values(items).some((poItems) => poItems.length > 0) && (
              <div className={classes.saveButtonRow}>
                <button
                  className={`${classes.saveButton} ${
                    isSaving ? classes.saveButtonDisabled : ""
                  }`}
                  onClick={handleSaveGRN}
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <>
                      <CircularProgress size={18} color="inherit" />
                      Saving...
                    </>
                  ) : (
                    "Save GRN"
                  )}
                </button>
              </div>
            )}

          <Modal open={successpopup}>
            <Fade in={successpopup}>
              <Box>
                <SuccessPopupDashboard
                  popupImage={successPopupImg}
                  popupHeroText={getuserpopupherotext}
                  popupDescription={
                    getuserpopupherotext === "GRN Saved Offline"
                      ? "Your GRN has been saved offline. Once the network is available, the system will automatically sync the data."
                      : ""
                  }
                  popBtn={true}
                  vendorBtn={true}
                  btnText={"Okay"}
                  btnClick={sentUserMessage}
                />
              </Box>
            </Fade>
          </Modal>

          <PaginantionComponent
            pageNumber={page}
            setPageNumber={(value) => {
              if (value === "") return;
              const parsed = parseInt(value, 10);
              if (!Number.isNaN(parsed)) {
                setPage(parsed);
              }
            }}
            currentPage={page}
            itemsPerPage={filteredGRN.length}
            totalItems={
              filteredGRN.length > 0
                ? Math.ceil(filteredGRN.length / rowsPerPage)
                : 0
            }
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
            onRowsPerPageChange={(event) => {
              const newRows = parseInt(event.target.value, 10);
              setRowsPerPage(Number.isNaN(newRows) ? rowsPerPage : newRows);
              setPage(1);
            }}
            previouPageClick={() => setPage((prev) => Math.max(1, prev - 1))}
            nextPageClick={() =>
              setPage((prev) =>
                filteredGRN.length > 0
                  ? Math.min(Math.ceil(filteredGRN.length / rowsPerPage), prev + 1)
                  : 1,
              )
            }
            disablePrevious={page <= 1}
            disableNext={
              filteredGRN.length === 0 ||
              page >= Math.ceil(filteredGRN.length / rowsPerPage)
            }
          />
        </div>
      </div>
    </>
  );
};

const formatDateTime = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const GRNTable = ({ title, data, poInvoiceMap, setSelectedGrn }) => {
  const navigate = useNavigate();
  const isCompleted = (items) =>
    items.every(
      (i) => Number(i.quantity_ordered) === Number(i.quantity_received),
    );

  return (
    <div className={classes.tableResponsiveWrapper}>
      <table className={classes.grnTable}>
        <thead>
          <tr>
            <th style={{ width: "70px", fontSize: "16px" }}>
              Goods Receipt ID
            </th>
            <th style={{ width: "130px", fontSize: "16px" }}>PO ID</th>
            <th style={{ width: "70px", fontSize: "16px" }}>
              Supplier Invoice ID
            </th>
            <th style={{ width: "150px", fontSize: "16px" }}>Supplier</th>
            <th style={{ width: "150px", fontSize: "16px" }}>Receiver</th>
            <th style={{ width: "200px", fontSize: "16px" }}>Created At</th>
            {/* <th>Status</th> */}
            <th style={{ width: "100px" }}>Approval Status</th>

            <th style={{ width: "100px" }}>View</th>
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((grn) => (
              <tr key={grn.grn_number}>
                <td>{grn.grn_number}</td>

                <td>{grn.purchase_order_no}</td>

                <td>
                  {grn.invoice_number ||
                    poInvoiceMap?.[grn.purchase_order_no] ||
                    "-"}
                </td>

                <td>{grn.vendor}</td>

                <td>{grn.receiver_name}</td>

                <td>{formatDateTime(grn.created_at)}</td>

                {/* <td>{isCompleted(grn.items) ? "Completed" : "Active"}</td> */}
                <td>
                  <Tooltip
                    arrow
                    placement="top"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "#1f2937",
                          fontSize: "14px",
                          padding: "12px 14px",
                          borderRadius: "8px",
                          maxWidth: "260px",
                          lineHeight: 1.6,
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#1f2937",
                        },
                      },
                    }}
                    title={
                      <Box>
                        {[
                          { level: 1, role: "Store Executive" },
                          { level: 2, role: "Store Manager" },
                        ].map((step) => {
                          const found = grn.approvals?.find(
                            (a) => a.approval_level === step.level,
                          );

                          const status = found ? found.status : "pending";
                          const approvedBy = found?.approved_by || "-";

                          return (
                            <Box
                              key={step.level}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 0.5,
                              }}
                            >
                              <span style={{ fontWeight: 600 }}>
                                {step.role}
                              </span>

                              <span
                                style={{
                                  color:
                                    status === "approved"
                                      ? "#22c55e"
                                      : status === "rejected"
                                        ? "#ef4444"
                                        : "#c96f1a",
                                  fontWeight: 600,
                                }}
                              >
                                {status.toUpperCase()}
                              </span>
                            </Box>
                          );
                        })}
                      </Box>
                    }
                  >
                    <span
                      style={{
                        padding: "6px 16px",
                        fontSize: "14px",
                        fontWeight: 600,
                        cursor: "pointer",
                        display: "inline-block",
                        letterSpacing: "0.3px",
                        color:
                          grn.overall_approval_status === "approved"
                            ? "#2e7d32"
                            : grn.overall_approval_status === "rejected"
                              ? "#c62828"
                              : "#ed6c02",
                      }}
                    >
                      {grn.overall_approval_status
                        ? grn.overall_approval_status.charAt(0).toUpperCase() +
                          grn.overall_approval_status.slice(1)
                        : "Awaiting"}
                    </span>
                  </Tooltip>
                </td>

                <td>
                  <IconButton
                    onClick={() =>
                      navigate(`/GRN_Dashboard/grn/${grn.grn_number}`, {
                        state: grn,
                      })
                    }
                  >
                    <VisibilityIcon color="primary" sx={{ fontSize: 18 }} />
                  </IconButton>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No {title.toLowerCase()} found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default GRNSystem;
